module.exports = __webpack_public_path__ + "media/images/frontend/vacunate.orig-53b5108497cbc7b36449b53e9fce72b2.png";